import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { TextLink } from '../../text-link/text-link.component';
import { useStepperCardContext } from '../provider/stepper-card.provider';
import { useStepperContext } from '../provider/stepper.provider';

const skipButtonStyle = css`
  margin: ${theme.spacing(0, 1)};
`;

export type StepperClearButtonProps = {
  skipTo?: number;
  trackingId?: string;
  children: string;
  className?: string;
};

export const StepperSkipButton = ({
  skipTo,
  trackingId = '',
  children = 'Skip',
  className,
  ...rest
}: Partial<StepperClearButtonProps>) => {
  const { skipFunction, nextFunction } = useStepperContext();
  const { step } = useStepperCardContext();

  const skip = () => {
    if (skipTo) {
      skipFunction(skipTo, step);
    } else {
      nextFunction(step);
    }
  };

  return (
    <TextLink
      className={cx('step-button skip-step', skipButtonStyle, className)}
      trackingId={trackingId}
      onClick={() => skip()}
      {...rest}
    >
      {children}
    </TextLink>
  );
};
